import createClient from "./supabase/client";

const supabaseClient = createClient();

export default supabaseClient;
